import { categoryConstants } from '../../constant';

const initialState = { categories: null };

export const fetch_categories_reducer = (state = initialState, action) => {
  switch (action.type) {
    case categoryConstants.FETCH_CATEGORIES_ACTION_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case categoryConstants.FETCH_CATEGORIES_ACTION_SUCCESS:
      return {
        categories: action.payload,
      };
    case categoryConstants.FETCH_CATEGORIES_ACTION_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};
